import uuid from 'uuid-random';
import React, { useEffect, useRef } from 'react';
import { scrollService } from '@core/js/services/scroll.service';

import style from './Overlay.scss';

export const Overlay = ({ className = '', ...props }) => {
    const lockIdRef = useRef(uuid());

    useEffect(() => {
        const lockId = lockIdRef.current;

        scrollService.disableBodyScroll(lockId);

        return () => scrollService.enableBodyScroll(lockId);
    }, []);

    return (
        <div className={`${style.overlay} ${className}`}
             // ~(TotalCasino Changes)~ Added second argument to onClick for condition to open hold on popup
            {...props} onClick={(e) => props?.onClick && props.onClick(e, true)}>
        </div>
    );
};

export default Overlay;
